import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination]);

export default class Home {
    constructor() {
        if (document.getElementById('home') !== null) {
            this.initHero();
            this.initProperties();
            this.initUsps();
            this.initBanners();
            this.initSocial();
            this.initProjects();
        }
        if (document.getElementById('logos') !== null) {
            this.initLogos();
        }
    }

    initHero() {
        new Swiper('#hero .swiper-container', {
            slidesPerView: 1,
            allowTouchMove: false,
            autoplay: {
                delay: 2500,
            }
        });
    }

    initProperties() {
        new Swiper('#properties .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            // autoplay: {
            //     delay: 2500,
            // },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                nextEl: '#properties .swiper-button-next',
                prevEl: '#properties .swiper-button-prev',
            }
        });
    }

    initUsps() {
        new Swiper('#usps .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 2500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                }
            }
        });
    }

    initBanners() {
        new Swiper('#banners .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 2500,
            },
            navigation: {
                nextEl: '#banners .swiper-button-next',
                prevEl: '#banners .swiper-button-prev',
            }
        });
    }

    initLogos() {
        new Swiper('#logos .swiper-container', {
            slidesPerView: 2,
            spaceBetween: 60,
            loop: true,
            autoplay: {
                delay: 1500,
            },
            breakpoints: {
                576: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 8,
                },
            }
        });
    }


    initProjects() {
        new Swiper('#projecten .project-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            autoplay: {
                delay: 2500,
            },
            navigation: {
                nextEl: '#projecten .swiper-button-next',
                prevEl: '#projecten .swiper-button-prev',
            },
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        arrows:false
                    }
                }
            ]
        });
    }

    initSocial() {
        new Swiper('#social .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 30,
            // autoplay: {
            //     delay: 2500,
            // },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                }
            }
        });
    }
}
